import React from "react";
import {Row, Col} from "react-bootstrap";
import TextArea from "../../../common/TextArea";
import Input from "../../../common/Input";
import DateBox from "../../../primer/DateBox";
import {useSelector, useDispatch} from "react-redux";
import {
    setSaveEditPOS
} from "../../../../_reducers/activitySlice";
import Checkbox from "../../../common/CheckBox";
import {setEditPOS} from "../../../../_reducers/DataPanel/Cash/cashSlice";
import BetterCheckBox from "../../../common/BetterCheckBox";
import {checkPermission, getAcquirerPOSOptions, isEmpty} from "../../../../_helpers/commonFunctions";
import LogTable from "../../../primer/LogTable";
import Dropdown from "../../../primer/Dropdown";
import {useTranslation} from "../../../../hooks/useTranslation";

const EditPos = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const saveEditPOS = useSelector((state) => state.ACTIVITY.saveEditPOS);
    const editPOS = useSelector((state) => state.CASH_DATA.editPOS);
    const permissionsData = JSON.parse(localStorage.getItem("user"))?.permissions;

    const handleOnChange = (e, type = "default", ddname = '') => {
        if (!saveEditPOS) dispatch(setSaveEditPOS(true));

        let name;
        let value;
        let posData = structuredClone(editPOS);
        if (type === 'dp') {
            value = e;
            name = ddname;
        } else if (type === "dd") {
            value = e.value;
            name = ddname;
        } else {
            value = e.target.value;
            name = e.target.name;
            if (name === "isETameiaki") {
                posData["isWebECR"] = "false";
                value = e.target.checked === true ? "active" : "inactive";
                posData[name] = value;
                if (!getAcquirerPOSOptions(posData).find((el) => el.value === posData.acquirer)) posData["acquirer"] = "";
            } else if (name === "isWebECR") {
                posData["isETameiaki"] = "inactive";
                value = e.target.checked === true ? "true" : "false";
                posData[name] = value;
                if (!getAcquirerPOSOptions(posData).find((el) => el.value === posData.acquirer)) posData["acquirer"] = "";
            }
        }
        posData[name] = value;
        dispatch(setEditPOS(posData));
    }

    return (
        <React.Fragment>
            <Row className="position-relative border-bottom mb-3">
                <Col xs="12" md="12" className="d-flex align-items-center justify-content-end ">
                    <div className="inline-field d-flex align-items-center acremd  mb-3">
                        <label htmlFor="product-active" className="mb-0 mr-2 ">{t('PosNewEdit.active')}</label>
                        <Checkbox
                            className="mb-2"
                            name="isActive"
                            key={Math.random()}
                            id="product-active"
                            defaultValue={editPOS.isActive}
                            value={editPOS.isActive === 'active' ? "inactive" : "active"}
                            onChange={(e) => handleOnChange(e)}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md={4}>
                    <Input
                        className="w-100"
                        label={t('PosNewEdit.name.name')}
                        name="name"
                        placeholder={t('PosNewEdit.name.placeholder')}
                        value={editPOS.name}
                        required={true}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveEditPOS && editPOS.name === '' &&
                        <div className="text-danger">{t('PosNewEdit.name.required')}</div>}
                </Col>
                {(editPOS.isETameiaki !== "active" && editPOS.isWebECR !== "true") && (
                    <Col md={4}>
                        <Dropdown
                            className={"mb-0"}
                            name={"acquirer"}
                            label={"Πάροχος Πληρωμών"}
                            required={true}
                            key={Math.random()}
                            defaultValue={getAcquirerPOSOptions(editPOS).find((el) => el.value === editPOS.acquirer)}
                            options={getAcquirerPOSOptions(editPOS)}
                            onChange={(e) => handleOnChange(e, "dd", "acquirer")}
                        />
                        {saveEditPOS && isEmpty(editPOS.acquirer) &&
                            <div className="text-danger">Απαιτείται ο πάροχος πληρωμών.</div>}
                    </Col>
                )}
            </Row>
            <Row>
                <Col sm="12" md="3">
                    <BetterCheckBox
                        name={"isETameiaki"}
                        text={t("PosNewEdit.isETameiaki")}
                        className="pt-2"
                        checked={editPOS.isETameiaki === "active"}
                        onChange={(e) => handleOnChange(e, "cb")}
                    />
                </Col>
            </Row>
            {editPOS.isETameiaki === "active" && (
                <div style={{border: "2px solid lightgray", borderRadius: "8px", padding: "10px"}} className={"mb-2"}>
                    <Row className="mb-3">
                        <Col sm="12" md="3">
                            <Input
                                name="tameiakiUsername"
                                label={t("PosNewEdit.tameiakiUsername.label")}
                                placeholder={t("PosNewEdit.tameiakiUsername.placeholder")}
                                required={true}
                                autoComplete={"off"}
                                value={editPOS.tameiakiUsername}
                                onChange={(e) => handleOnChange(e)}
                            />
                            {saveEditPOS && String(editPOS.tameiakiUsername).trim() === "" && (
                                <div className="text-danger">{t("PosNewEdit.tameiakiUsername.required")}</div>)}
                        </Col>
                        <Col sm="12" md="3">
                            <Input
                                name="tameiakiPassword"
                                label={t("PosNewEdit.tameiakiPassword.label")}
                                placeholder={t("PosNewEdit.tameiakiPassword.placeholder")}
                                required={true}
                                autoComplete={"off"}
                                value={editPOS.tameiakiPassword}
                                onChange={(e) => handleOnChange(e)}
                            />
                            {saveEditPOS && String(editPOS.tameiakiPassword).trim() === "" && (
                                <div className="text-danger">{t("PosNewEdit.tameiakiPassword.required")}</div>)}
                        </Col>
                        <Col sm="12" md="3">
                            <Input
                                name="tid"
                                label={"TID"}
                                placeholder={"TID"}
                                required={true}
                                autoComplete={"off"}
                                value={editPOS.tid}
                                onChange={(e) => handleOnChange(e)}
                            />
                            {saveEditPOS && String(editPOS.tid).trim() === "" && (
                                <div className="text-danger">{t("PosNew.tid.required")}</div>)}
                        </Col>
                        <Col md={3}>
                            <Dropdown
                                className={"mb-0"}
                                name={"acquirer"}
                                label={"Πάροχος Πληρωμών"}
                                required={true}
                                key={Math.random()}
                                defaultValue={getAcquirerPOSOptions(editPOS).find((el) => el.value === editPOS.acquirer)}
                                options={getAcquirerPOSOptions(editPOS)}
                                onChange={(e) => handleOnChange(e, "dd", "acquirer")}
                            />
                            {saveEditPOS && isEmpty(editPOS.acquirer) &&
                                <div className="text-danger">Απαιτείται ο πάροχος πληρωμών.</div>}
                        </Col>
                        {!isEmpty(editPOS?.deviceSN) && (
                            <Col sm="12" md="3">
                                <Input
                                    name="deviceSN"
                                    disabled={true}
                                    label={"Device Serial Number"}
                                    placeholder={"Device Serial Number"}
                                    autoComplete={"off"}
                                    value={editPOS.deviceSN}
                                    onChange={(e) => handleOnChange(e)}
                                />
                            </Col>
                        )}
                    </Row>
                </div>
            )}
            <Row>
                <Col sm="12" md="3">
                    <BetterCheckBox
                        name={"isWebECR"}
                        text={"Διασύνδεση με Web ECR"}
                        className="pt-2"
                        checked={editPOS.isWebECR === "true"}
                        onChange={(e) => handleOnChange(e, "cb")}
                    />
                </Col>
            </Row>
            {editPOS.isWebECR === "true" && (
                <div style={{border: "2px solid lightgray", borderRadius: "8px", padding: "10px"}} className={"mb-2"}>
                    <Row>
                        <Col md={3}>
                            <Input
                                name="webECR_ecrCode"
                                label={"Κωδικός ECR (ECR code)"}
                                required={true}
                                autoComplete={"off"}
                                value={editPOS.webECR_ecrCode}
                                onChange={(e) => handleOnChange(e)}
                            />
                            {saveEditPOS && isEmpty(editPOS.webECR_ecrCode) && (
                                <div className="text-danger">Απαιτείται κωδικός ECR.</div>)}
                        </Col>
                        <Col md={3}>
                            <Input
                                name="webECR_tid"
                                label={"TID"}
                                required={true}
                                autoComplete={"off"}
                                value={editPOS.webECR_tid}
                                onChange={(e) => handleOnChange(e)}
                            />
                            {saveEditPOS && isEmpty(editPOS.webECR_tid) && (
                                <div className="text-danger">Απαιτείται TID.</div>)}
                        </Col>
                        <Col md={3}>
                            <Dropdown
                                className={"mb-0"}
                                name={"acquirer"}
                                label={"Πάροχος Πληρωμών"}
                                required={true}
                                key={Math.random()}
                                defaultValue={getAcquirerPOSOptions(editPOS).find((el) => el.value === editPOS.acquirer)}
                                options={getAcquirerPOSOptions(editPOS)}
                                onChange={(e) => handleOnChange(e, "dd", "acquirer")}
                            />
                            {saveEditPOS && isEmpty(editPOS.acquirer) &&
                                <div className="text-danger">Απαιτείται ο πάροχος πληρωμών.</div>}
                        </Col>
                    </Row>
                </div>
            )}
            <Row>
                <Col sm="12" md="4">
                    <div className="mb-3">
                        <DateBox
                            classes="w-100"
                            label={t('PosNewEdit.date.date')}
                            name="date"
                            required={true}
                            selected="today"
                            allowOtherYears={true}
                            onChange={(e) => handleOnChange(e, 'dp', 'date')}
                        />
                        {saveEditPOS && isEmpty(editPOS.date) &&
                            <div className="text-danger">{t('PosNewEdit.date.required')}</div>}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col sm="12" md="8">
                    <div className="mb-3">
                        <Input
                            className="w-100"
                            label={t('PosNewEdit.serialNumber.serialNumber')}
                            name="serialNumber"
                            placeholder={t('PosNewEdit.serialNumber.placeholder')}
                            value={editPOS.serialNumber}
                            required={true}
                            autoComplete={"off"}
                            onChange={(e) => handleOnChange(e)}
                        />
                        {saveEditPOS && editPOS.serialNumber === '' &&
                            <div className="text-danger">{t('PosNewEdit.serialNumber.required')}</div>}
                    </div>
                </Col>
            </Row>
            <hr className="mb-4"/>
            <Row>
                <div style={{width: "100%"}}>
                    <div className="text-muted mb-2"><i>{t('PosNewEdit.notes')}</i></div>
                    <TextArea
                        rows="4"
                        placeholder={t('PosNewEdit.addNotes')}
                        name="notes"
                        limit="1000"
                        value={editPOS.notes}
                        onChange={(e) => handleOnChange(e)}
                    />
                </div>
            </Row>
            {checkPermission("accounting-settings/accounting-read", permissionsData) === true && (
                <React.Fragment>
                    <hr/>
                    <div className="text-muted mb-2"><i>Λογιστική</i></div>
                    <Row className={"mb-2"}>
                        <Col md={4}>
                            <Input
                                name={"accounting"}
                                label={"Πρόθεμα Κωδικού Λογαριασμού"}
                                value={editPOS?.accounting}
                                autoComplete={"off"}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </Col>
                        <Col md={4}>
                            <Input
                                name={"bypassAccounting"}
                                label={"Κωδικός Λογαριασμού Παράκαμψης Λογιστικής Γέφυρας"}
                                value={editPOS?.bypassAccounting}
                                autoComplete={"off"}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </Col>
                    </Row>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export const PosEditLog = () => {
    const {t} = useTranslation();
    const editPOS = useSelector((state) => state.CASH_DATA.editPOS);

    return (
        <React.Fragment>
            <div className="text-muted mb-2"><i>{t('Logs.posLog')}</i></div>
            <LogTable itemId={editPOS._id}/>
        </React.Fragment>
    )
}

export default EditPos;
